import { render, staticRenderFns } from "./journal-list-item.vue?vue&type=template&id=2a7088a8"
import script from "./journal-list-item.vue?vue&type=script&lang=js"
export * from "./journal-list-item.vue?vue&type=script&lang=js"
import style0 from "./journal-list-item.vue?vue&type=style&index=0&id=2a7088a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports